var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.25C4.36914 0.25 0.25 4.40527 0.25 9.5C0.25 14.6309 4.36914 18.75 9.5 18.75C14.5947 18.75 18.75 14.6309 18.75 9.5C18.75 4.40527 14.5947 0.25 9.5 0.25ZM12.3906 11.1982C12.7158 11.5596 12.7158 12.1016 12.3906 12.4268C12.0293 12.7881 11.4873 12.7881 11.1621 12.4268L9.5 10.7285L7.76562 12.4268C7.44043 12.7881 6.89844 12.7881 6.57324 12.4268C6.21191 12.1016 6.21191 11.5596 6.57324 11.1982L8.27148 9.5L6.57324 7.80176C6.21191 7.44043 6.21191 6.89844 6.57324 6.57324C6.89844 6.21191 7.44043 6.21191 7.76562 6.57324L9.5 8.30762L11.1982 6.60938C11.5234 6.24805 12.0654 6.24805 12.3906 6.60938C12.752 6.93457 12.752 7.47656 12.3906 7.83789L10.6924 9.53613L12.3906 11.1982Z",
    fill: "#D70015"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross-red.fb5bc938990eb468cf3cce414705dc22.svg";
export { ForwardRef as ReactComponent };